"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
exports.__esModule = true;
var DOMScript_1 = require("@/scripts/utils/DOMScript");
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var FeaturesSection = /** @class */ (function () {
    function FeaturesSection() {
    }
    FeaturesSection.prototype.onLoadEach = function ($element) {
        var $toggler = $element.$(".accordion-item-header");
        var $body = $element.$(".accordion-item-body");
        var $icon = $element.$(".accordion-item-header__icon");
        var openAccordion = function (isOpen) {
            if (isOpen === void 0) { isOpen = false; }
            $body.style.height = "".concat(isOpen ? $body.scrollHeight : 0, "px");
            $icon.$classAddOrRemoveIf(isOpen, "--active");
            $body.$classAddOrRemoveIf(isOpen, "--active");
            $body.setAttribute("aria-hidden", "".concat(!isOpen));
            $body.setAttribute("tabindex", "".concat(isOpen ? -1 : 0));
        };
        var _a = $element.dataset.open, isOpenByDefault = _a === void 0 ? "no" : _a;
        if (isOpenByDefault == "yes" && window.innerWidth >= 768)
            openAccordion(true);
        var untilRefresh = (0, DOMScript_1.makeUntilRefresh)();
        $toggler &&
            $body &&
            untilRefresh((0, rxjs_1.fromEvent)($toggler, "click"))
                .pipe((0, operators_1.scan)(function (isOpen) { return !isOpen; }, isOpenByDefault == "yes" && window.innerWidth >= 768 ? true : false))
                .subscribe(function (isOpen) { return openAccordion(isOpen); });
        (0, rxjs_1.fromEvent)(window, "resize").subscribe(function () { return openAccordion(false); });
    };
    FeaturesSection = __decorate([
        (0, DOMScript_1.DOMBlock)({
            selector: ".AccordionItem",
            isElementArray: true
        })
    ], FeaturesSection);
    return FeaturesSection;
}());
new FeaturesSection();
